import { BFFAgent } from 'BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_FAILURE
} from '../constants'

export function getImagesExpertise(verificationId) {
  return async (dispatch) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_BEGIN
    })

    try {
      const galeryImagesRowDown = await BFFAgent.Peritador.getFiles(verificationId, "image")
      
      let galeryImagesRowUp = []
      if (galeryImagesRowDown.length > 12) {
        if (galeryImagesRowDown.length % 2) {
          galeryImagesRowUp = galeryImagesRowDown.splice(0, Math.round(galeryImagesRowDown.length / 2))
        } else {
          galeryImagesRowUp = galeryImagesRowDown.splice(0, galeryImagesRowDown.length / 2)
        }
      } else if(galeryImagesRowDown.length > 6){
        galeryImagesRowUp = galeryImagesRowDown.splice(0, 6)
      }

      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_SUCCESS,
        data: { galeryImagesRowUp, galeryImagesRowDown }
      })
    } catch (err) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_FAILURE,
        data: err?.message
      })
    }
  }
}
